var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.333 13.9165L152.083 34.6665L136.265 50.4918L115.515 29.7418L131.333 13.9165Z",
    fill: "#F2A618"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.333 110.667H76.083L126.485 60.2651L105.735 39.5151L55.333 89.9168V110.667Z",
    fill: "#F2A618"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.417 131.417H56.4262C56.2463 131.417 56.0596 131.486 55.8798 131.486C55.6515 131.486 55.4232 131.424 55.1881 131.417H34.5833V34.5833H81.9417L95.7751 20.75H34.5833C26.9542 20.75 20.75 26.9473 20.75 34.5833V131.417C20.75 139.053 26.9542 145.25 34.5833 145.25H131.417C135.085 145.25 138.604 143.793 141.198 141.198C143.793 138.604 145.25 135.085 145.25 131.417V71.463L131.417 85.2963V131.417Z",
    fill: "#F2A618"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.79cd38c94eb03def60a39c2ebeba2cf5.svg";
export { ForwardRef as ReactComponent };